"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var step_1 = require("../step");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var ApiService_1 = require("CreatePageFlow/ApiService");
var inversify_react_1 = require("inversify-react");
var RainbowLoadingBar_1 = __importDefault(require("../../../Client/Application/Common/AtomicUI/RainbowLoadingBar/RainbowLoadingBar"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var types_1 = require("CreatePageFlow/types");
var BouncingQwilrLogo_1 = __importDefault(require("CreatePageFlow/CreatePageComponents/BouncingQwilrLogo"));
var ErrorCodes_1 = require("@CommonFrontendBackend/ErrorCodes/ErrorCodes");
var CreatePageTelemetry_1 = __importDefault(require("../CreatePageTelemetry"));
var utils_1 = require("../utils");
var axios_1 = __importDefault(require("axios"));
var MINIMUM_LOAD_DELAY_MS = 3000;
var c = (0, BemBuilder_1.default)("create-page-flow-creating");
var Creating = (function (_super) {
    __extends(Creating, _super);
    function Creating(props) {
        var _this = _super.call(this, props) || this;
        _this.percent = 0;
        _this.interval = undefined;
        _this.createPage = function () { return __awaiter(_this, void 0, Promise, function () {
            var store, createPageBody, requestsMade, _a, page, editorUrl, error_1, reponseData, additionalInfo;
            var _b, _c, _d, _e, _f, _g, _h;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        store = this.props.store;
                        createPageBody = {
                            templateId: store.templateId,
                            extraData: {
                                name: store.pageTitle,
                                parentFolder: store.folderId,
                            },
                            substitutions: store.substitutions,
                        };
                        requestsMade = [];
                        if (store.integrationName && (0, utils_1.isPlatformSupportedIntegration)(store.integrationName)) {
                            if (!store.objectId) {
                                throw new Error("ObjectId is required to create page.");
                            }
                            if (!store.template) {
                                throw new Error("Template object is required to create page.");
                            }
                            if (!store.template.crmInfo.integration || !store.template.crmInfo.object) {
                                throw new Error("Invalid crmInfo in the template.");
                            }
                            createPageBody.integrationData = {
                                name: store.template.crmInfo.integration,
                                objectType: store.template.crmInfo.object,
                                objectId: store.objectId,
                            };
                            requestsMade.push(this.delay());
                        }
                        _j.label = 1;
                    case 1:
                        _j.trys.push([1, 3, , 4]);
                        return [4, Promise.all(__spreadArray([this.apiService.createPage(createPageBody)], __read(requestsMade), false))];
                    case 2:
                        _a = __read.apply(void 0, [_j.sent(), 1]), page = _a[0];
                        store.setCreatedPage(page);
                        this.telemetry.projectCreated({
                            integrationName: store.integrationName,
                            templateId: store.templateId,
                            source: (_d = (_c = (_b = store.template) === null || _b === void 0 ? void 0 : _b.tailoredTemplateType) === null || _c === void 0 ? void 0 : _c.toLowerCase()) !== null && _d !== void 0 ? _d : "user template",
                            createdUsingForm: !!((_e = store.tokenList) === null || _e === void 0 ? void 0 : _e.length),
                            createdFromOnboardingTemplate: !!((_f = store.template) === null || _f === void 0 ? void 0 : _f.isTailoredTemplate),
                        });
                        if (store.integrationName && (0, utils_1.isPlatformSupportedIntegration)(store.integrationName)) {
                            this.props.moveStep(1);
                        }
                        else {
                            editorUrl = page.urls.editorUrl;
                            if (store.projectTour) {
                                editorUrl = "".concat(editorUrl, "?tour=").concat(store.projectTour);
                            }
                            window.location.href = editorUrl;
                        }
                        return [3, 4];
                    case 3:
                        error_1 = _j.sent();
                        if (axios_1.default.isAxiosError(error_1) && ((_g = error_1.response) === null || _g === void 0 ? void 0 : _g.status) === 404) {
                            reponseData = (_h = error_1.response) === null || _h === void 0 ? void 0 : _h.data;
                            additionalInfo = (reponseData === null || reponseData === void 0 ? void 0 : reponseData.error).additionalInfo;
                            if ((additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.errorCode) === ErrorCodes_1.ServerErrorCode.FolderDoesNotExist) {
                                this.props.store.setCreatingPageError("Someone has deleted your selected folder.");
                                this.props.store.setFolderId(null);
                            }
                            else if ((additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.errorCode) === ErrorCodes_1.ServerErrorCode.ProjectDoesNotExist) {
                                this.props.store.setCreatingPageError("Someone has deleted your selected template. Please start over.");
                            }
                        }
                        else {
                            this.props.store.setCreatingPageError("Unable to create page.");
                        }
                        this.props.moveStep(-1);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        }); };
        _this.delay = function () {
            return new Promise(function (resolve) {
                _this.interval = window.setInterval(function () {
                    if (_this.percent === 100) {
                        window.clearInterval(_this.interval);
                        _this.interval = undefined;
                        resolve();
                    }
                    else {
                        _this.incrementPercent();
                    }
                }, MINIMUM_LOAD_DELAY_MS / 100);
            });
        };
        _this.images = {
            qwilr: "".concat(types_1.ASSETS_DIR, "Images/LogoColor.svg"),
        };
        return _this;
    }
    Creating.prototype.incrementPercent = function () {
        this.percent++;
    };
    Creating.prototype.componentDidMount = function () {
        this.createPage();
    };
    Creating.prototype.componentWillUnmount = function () {
        if (this.interval) {
            window.clearInterval(this.interval);
        }
    };
    Creating.prototype.render = function () {
        return (react_1.default.createElement("div", { className: c() }, this.props.store.integrationName && (0, utils_1.isPlatformSupportedIntegration)(this.props.store.integrationName) ? (react_1.default.createElement("div", { className: c("content") },
            react_1.default.createElement(BouncingQwilrLogo_1.default, null),
            react_1.default.createElement("div", { className: "space-stack-m" },
                react_1.default.createElement(kaleidoscope_1.Heading, { level: "2" }, "Creating page")),
            react_1.default.createElement("div", { className: "space-stack-xl" },
                react_1.default.createElement(kaleidoscope_1.Text, { className: c("subtitle"), size: "l", secondary: true, strong: true }, "Hang tight, we're creating your Qwilr page magic...")),
            react_1.default.createElement("div", { className: c("progress-bar") },
                react_1.default.createElement(RainbowLoadingBar_1.default, { percent: this.percent })))) : (react_1.default.createElement(kaleidoscope_1.Spinner, { size: "l", primary: true }))));
    };
    var _a, _b, _c;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], Creating.prototype, "percent", void 0);
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_b = typeof CreatePageTelemetry_1.default !== "undefined" && CreatePageTelemetry_1.default) === "function" ? _b : Object)
    ], Creating.prototype, "telemetry", void 0);
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_c = typeof ApiService_1.ApiService !== "undefined" && ApiService_1.ApiService) === "function" ? _c : Object)
    ], Creating.prototype, "apiService", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Creating.prototype, "incrementPercent", null);
    Creating = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [typeof (_a = typeof step_1.StepProps !== "undefined" && step_1.StepProps) === "function" ? _a : Object])
    ], Creating);
    return Creating;
}(react_1.default.Component));
exports.default = Creating;
